export function slugify(str = "") {
  return String(str)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .slice(0, 80) || "ad";
}

/**
 * Build clean SEO URL: /:categorySlug/:title-slug-:adId
 * The adId (e.g. ad_xxxx) is preserved verbatim as the last "-ad_XXX" segment
 * so we can extract it on the detail page.
 */
export function buildAdPath(listing) {
  const cat = listing.category_slug || "ad";
  const title = slugify(listing.title || "");
  return `/${cat}/${title}-${listing.id}`;
}

/** Extract the listing id from a `:adSlug` route param. */
export function extractAdId(slug = "") {
  // Underscore included so legacy seeded ids like `ad_xtest_featured` resolve
  // to the same shape the SSR /api/seo/render endpoint recognises.
  // Iter-374 — new listings use `cl_…` ids, and the detail API also resolves
  // bare numeric listing numbers (legacy ads), so accept all three shapes.
  const m = slug.match(/((?:ad_|cl_)[a-zA-Z0-9_]+|\d+)$/);
  return m ? m[1] : slug;
}
